import { get } from './base/index';
import { post } from './base/index';

export default {
  getAllPromotions: async (param) =>
    await get(`promotion/all${param}`),
  savePromotion: async (title,message) =>
    await post(`promotion/create`, {title,message})
};
